import type { MenuItem, NavigationWidgetData } from '@web/widgets/navigation/type/navigation-widget.type';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WebBaseViewComponent } from '@web/widgets/common/abstract/web-base-view.component';

import { EButtonLinkType } from '@common/enums';

import { getStyles } from './navigation-view.component.styles';

import { BLANK_LOGO } from '@web/widgets/image/constants/image.consts';
import { EffectTypes } from '@web/shared/components/web-hover-effects/types';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'web-navigation-view',
    templateUrl: './navigation-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, NgIf],
})
export class NavigationViewComponent extends WebBaseViewComponent<NavigationWidgetData> {
    protected getStyles = getStyles;

    public get image(): string {
        return BLANK_LOGO;
    }

    public get menuList(): MenuItem[] {
        return this.widgetData.menuList;
    }

    public getTarget(item: MenuItem): string {
        return item.isTargetBlank ? '_blank' : '_self';
    }

    public getHref(item: MenuItem): string {
        const { linkUrl, linkType } = item;
        const trimmedValue = linkUrl?.trim() || '';

        switch (linkType) {
            case EButtonLinkType.phone:
                return `tel:${trimmedValue}`;
            case EButtonLinkType.email:
                return `mailto:${trimmedValue}`;
            case EButtonLinkType.link:
            default:
                return trimmedValue;
        }
    }

    public get animationClass(): string {
        return this.widgetData?.hoverEffects?.type === EffectTypes.animation
            ? this.widgetData?.hoverEffects?.animationType
            : null;
    }

    public getVisibleSubmenuItemList(item: MenuItem): boolean {
        if (item?.submenuList) {
            return Boolean(item.submenuList.find((item) => item.isVisible));
        } else {
            return false;
        }
    }
}
